import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Collapse} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {hasMultipleSubscriptions, getManagementLink, hasManualBilling} = customer.selectors;
const {logout} = customer.actions;

import {showSelectStoreModal, showChangePasswordModal} from '../actions';

import NavUserInfo from './NavUserInfo';

import * as permissions from '../../common/userPermissions';

function activeLinkClass(location, link) {
  return location === link ? 'active' : '';
}

const NavLinkBar = ({ 
  actions,
  isMasterUser,
  managementLink,
  manualBilling,
  multipleSubscriptions,  
  navLocation,
  navCollapsed,
  onClick,
  onTransitionComplete,
  userPermissions,
  isDemoUser 
}) => {
  let navSubClass = `nav-sub ${multipleSubscriptions ? 'multi-store' : ''}`;
  
  const adsAccess = userPermissions.find((permission) => {
    return permission === permissions.MANAGE_CARE_SHEET_ADS;
  });

  const logoAccess = userPermissions.find((permission) => {
    return permission === permissions.MANAGE_LOGO;
  });

  const articlesAccess = userPermissions.find((permission) => {
    return permission === permissions.MANAGE_ARTICLES;
  });

  return (
    <div className={navSubClass}>
      <NavUserInfo onClick={onClick} useCollapsedStyle={navCollapsed}/>
      <Collapse className="menu-content" isOpen={!navCollapsed} onOpened={onTransitionComplete} onClosed={onTransitionComplete}>
        {adsAccess && <li className={activeLinkClass(navLocation, '/ads')}>
          <Link to="/ads" onClick={onClick}>{I18n.t('ADVERTISING_SPACE')}</Link>
        </li>}
        {logoAccess && <li className={activeLinkClass(navLocation, '/store')}>
          <Link to="/store" onClick={onClick}>{I18n.t('STORE_INFO_LOGO')}</Link>
        </li>}
        {articlesAccess && <li className={activeLinkClass(navLocation, '/articles')}>
          <Link to="/articles" onClick={onClick}>{I18n.t('ARTICLE_MANAGEMENT')}</Link>
        </li>}
        {(isMasterUser && !isDemoUser) && <li className={activeLinkClass(navLocation, '/users')}>
          <Link to="/users" onClick={onClick}>{I18n.t('USERS')}</Link>
        </li>}
        <li>
          <Link className="label-link" onClick={actions.showChangePasswordModal}>
            {I18n.t('CHANGE_PASSWORD')}
          </Link>
        </li>
        {multipleSubscriptions && 
          <li>
            <Link className="label-link" onClick={actions.showSelectStoreModal}>
              {I18n.t('CHANGE_STORE')}
            </Link>
          </li> 
        }
        {(isMasterUser && !manualBilling) && <li><a href={managementLink} target="_blank">{I18n.t('MANAGEMENT')}</a></li>}
        <li>
          <Link onClick={actions.logout}>{I18n.t('LOG_OUT')}</Link>
        </li>
      </Collapse>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    managementLink: getManagementLink(state),
    manualBilling: hasManualBilling(state),
    multipleSubscriptions: hasMultipleSubscriptions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({logout, showSelectStoreModal, showChangePasswordModal}, dispatch)
  };
}

NavLinkBar.propTypes = {
  actions: PropTypes.object.isRequired,
  manualBilling: PropTypes.bool.isRequired,
  isMasterUser: PropTypes.bool.isRequired,
  managementLink: PropTypes.string.isRequired,
  multipleSubscriptions: PropTypes.bool.isRequired,
  navCollapsed: PropTypes.bool.isRequired,
  navLocation: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onTransitionComplete: PropTypes.func.isRequired,
  userPermissions: PropTypes.array.isRequired,
  isDemoUser:  PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(NavLinkBar);


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/NavLinkBar.js
 **/